import React from "react";
import { cn } from "@/lib/utils";

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  children: React.ReactNode;
}

// Inline SVG chevron matching the style-guide (stroke: ink-muted #9A9285)
const chevronBg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%239A9285' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`;

const FormSelect = React.forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ className, children, style, ...props }, ref) => {
    return (
      <select
        className={cn(
          "w-full h-8 bg-white rounded-md border border-edge-input px-3 pr-8 py-0 text-left text-sm leading-normal text-ink [&:invalid]:text-ink-muted outline-none focus:outline-none focus:ring-0 focus:border-sage appearance-none bg-no-repeat cursor-pointer",
          className
        )}
        style={{
          backgroundImage: chevronBg,
          backgroundPosition: "right 10px center",
          textAlign: "left",
          textAlignLast: "left",
          ...style,
        }}
        ref={ref}
        {...props}
      >
        {children}
      </select>
    );
  }
);
FormSelect.displayName = "FormSelect";

export { FormSelect };
export type { FormSelectProps };
